import React, { useContext, useEffect, useRef, useState } from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import { withVisibility } from './collapsible-button-chart';
import { KPIChartsSearch, OccupancyAndAverageDailyRate } from '../../shared/models/kpis.model';
import { OccupancyAndAverageDailyRateDataContext } from '../shared/services/OccupancyAndAverageDailyRate-provider';

const TotalRevenueChart: React.FC<{ query: KPIChartsSearch }> = ({ query }) => {
  const data = useContext<OccupancyAndAverageDailyRate[] | null>(
    OccupancyAndAverageDailyRateDataContext
  );

  const [chartOptions, setChartOptions] = useState<Highcharts.Options>({
    chart: {
      type: 'column',
      showCheckbox: true
    },
    title: {
      text: 'GMV',
      align: 'left'
    },
    xAxis: {
      categories: [
        'Jan',
        'Feb',
        'March',
        'Apr',
        'May',
        'June',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ],
      crosshair: true,
      accessibility: {
        description: 'Months'
      }
    },
    yAxis: [
      {
        title: {
          text: 'EGP'
        }
      },
      {
        title: {
          text: 'USD'
        },
        opposite: true
      }
    ],
    plotOptions: {
      column: {
        borderWidth: 0,
        pointPadding: 0
      }
    },
    series: [
      {
        name: 'Total',
        data: [],
        color: '#1d4ed8',
        yAxis: 0
      },
      {
        name: 'EGP',
        data: [],
        color: '#f38831',
        yAxis: 0
      },
      {
        name: 'USD',
        data: [],
        color: '#008343',
        yAxis: 1
      }
    ]
  });
  const chartComponentRef = useRef<any>(null);

  const getOccupancyAndAverageDailyRates = (response: OccupancyAndAverageDailyRate[]) => {
    chartComponentRef?.current?.chart?.hideLoading();
    const categories = response.map((revenue) => revenue.month.slice(0, 3).toUpperCase());
    const egpMonthsRevenue = response.map((revenue) => revenue.MonthlyRevenueEGP ?? 0);
    const usdMonthsRevenue = response.map((revenue) => revenue.MonthlyRevenueUSD ?? 0);
    const totalMonthsRevenue = response.map((revenue) => revenue.MonthlyRevenueTotal ?? 0);

    const sum = totalMonthsRevenue?.reduce((acc: number, curr) => acc + curr, 0);

    const chartUpdatedOptions = {
      ...chartOptions,
      title: {
        text: `GMV (Total: ${new Intl.NumberFormat('en-US').format(sum)} EGP)`,
        align: 'left'
      },
      xAxis: {
        ...chartOptions.xAxis,
        categories
      },
      series: [
        { ...chartOptions.series[0], data: totalMonthsRevenue },
        { ...chartOptions.series[1], data: egpMonthsRevenue },
        { ...chartOptions.series[2], data: usdMonthsRevenue }
      ]
    };
    setChartOptions(chartUpdatedOptions);
  };

  useEffect(() => {
    if (data) {
      getOccupancyAndAverageDailyRates(data);
    } else {
      chartComponentRef?.current?.chart?.showLoading();
    }
  }, [data]);

  return <HighchartsReact ref={chartComponentRef} highcharts={Highcharts} options={chartOptions} />;
};

export default withVisibility(TotalRevenueChart);
